export const fallbackModelLanguage = 'de';
